import { ErrorResponseDtoFromJSON } from "@desio/api";
import { createReducer } from "@reduxjs/toolkit";
import { refreshCertificazioniLottoType, refreshDettaglioLottoType } from "pages/admin/campagne/dettaglio-campagna/_redux/actions";
import { addLottoType } from "pages/admin/campagne/nuova-campagna/_redux/actions";
import { hideLoader, resetGeneralError, setGeneralError, showLoader } from "./actions";
import { GeneralReducerType } from "./types";

const initialState: GeneralReducerType = {
  generalLoader: 0,
  loader: {},
  error: ErrorResponseDtoFromJSON({})
};

const whitelistLoader = [
  addLottoType + '/pending',
  addLottoType + '/fulfilled',
  addLottoType + '/rejected',
  refreshDettaglioLottoType + '/pending',
  refreshDettaglioLottoType + '/fulfilled',
  refreshDettaglioLottoType + '/rejected',
  refreshCertificazioniLottoType + '/pending',
  refreshCertificazioniLottoType + '/fulfilled',
  refreshCertificazioniLottoType + '/rejected'
];

export const generalReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(showLoader, (state, action) => {
      if (!action.payload) {
        state.generalLoader = state.generalLoader + 1;
      } else {
        state.loader[action.payload] = (state.loader[action.payload] || 0) + 1;
      }
    })
    .addCase(hideLoader, (state, action) => {
      if (!action.payload) {
        state.generalLoader = state.generalLoader - 1;
      } else {
        state.loader[action.payload] = (state.loader[action.payload] || 0) - 1;
      }
    })
    .addCase(setGeneralError, (state, action) => {
      state.error = action.payload;
    })
    .addCase(resetGeneralError, (state) => {
      state.error = initialState.error;
    })

    .addMatcher(action => action.type.endsWith('/pending'), (state, action) => {
      if (!whitelistLoader.includes(action.type)) {
        state.generalLoader = state.generalLoader + 1;
      }
    })
    .addMatcher(action => action.type.endsWith('/fulfilled') || action.type.endsWith('/rejected'), (state, action) => {
      if (!whitelistLoader.includes(action.type)) {
        state.generalLoader = state.generalLoader - 1;
      }
    })

});
